import React, { useEffect, useState } from "react";

function Stock({ variation, config }) {

    const instock = (variation) => {
        if (variation.quantity > 0) {
            return true
        } else if (variation.backorder) {
            return true
        } else {
            return false
        }
    }

    const calculateTimeLeft = () => {

        let timeLeft = {};

        let today = new Date()
        today.setHours(config.shipping_cutoff_time.split(":")[0], config.shipping_cutoff_time.split(":")[1], 0)
        // lets check if we are after our cutoff time today

        // compare to 'now'
        let difference = today - +new Date();
        // meaning we have time left till dispatch time
        if (difference > 0) {
            // check which day of the week we are in - Monday [1]- Friday [5] we can dispatch today, Sat + Sun we dispatch on the Monday
            timeLeft = {
                day: (today.getDay() > 0 && today.getDay() < 6) ? ('today') : ('on Monday'),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
            };
        } else {
            // meaning we are past todays dispatch time
            // check which day of the week we are in - Sunday [0] - Thursday [4] we can dispatch 'tomorrow', Fri + Sat we dispatch on the Monday
            let tomorrow = new Date()
            tomorrow.setHours(config.shipping_cutoff_time.split(":")[0], config.shipping_cutoff_time.split(":")[1], 0)
            tomorrow.setDate(tomorrow.getDate() + 1)

            let difference = tomorrow - +new Date();

            if (difference > 0) {
                timeLeft = {
                    day: (today.getDay() < 5) ? ('tomorrow') : ('on Monday'),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60)
                };
            }
        }

        return timeLeft;
    }

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000 * 60);
    });

    return (
        <>
            <div className="border-t border-gray-300 pt-6 my-6" {...variation.sku == '520-388-0842' && {'data-nosnippet' : ''}}>
            {(variation.variation_status == null || variation.variation_status == '') ? (
                <>
                    {instock(variation) ? (
                        <>

                            {(variation.quantity > 0) ? (
                                <>
                                    <div className="text-green-700 font-medium text-base mb-2 leading-none">
                                        <i className="fas fa-check-circle mr-1"></i> {(variation.quantity > 50 ? '50+' : variation.quantity)} In Stock
                                    </div>
                                    <div className="text-sm text-gray-600">Order within <strong>{timeLeft.hours} hrs {timeLeft.minutes} mins</strong> for <strong>dispatch {timeLeft.day}.</strong></div>
                                </>
                            ) : (
                                <>
                                    <div className="text-sm text-gray-600">
                                        {(variation.lead_time_value) ?
                                            (
                                                (variation.lead_time_units == 'Day(s)' || variation.lead_time_units == 'Days') ? (
                                                    <>
                                                        Lead Time Approx. <strong>{Number(variation.lead_time_value) + Number(1)} Working Day(s)</strong>
                                                    </>
                                                ) : (
                                                    <>
                                                        Lead Time Approx. <strong>{variation.lead_time_value} {(variation.lead_time_units == 'Week(s)' || variation.lead_time_units == 'Weeks') ? ('Week(s)'):('Month(s)')}</strong>
                                                    </>
                                                )
                                            ) : (
                                                <>
                                                    Lead Time Approx. <strong>2-5 Working Days</strong>
                                                </>
                                            )}
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <div className="text-red-700 font-medium text-base mb-2 leading-none">
                                <i className="fas fa-check-circle"></i> Out of Stock
                            </div>
                            <div className="text-sm text-gray-600">
                                {(variation.lead_time_value) ?
                                    (
                                        (variation.lead_time_units == 'Day(s)' || variation.lead_time_units == 'Days') ? (
                                            <>
                                                Lead Time Approx. <strong>{Number(variation.lead_time_value) + Number(1)} Working Day(s)</strong>
                                            </>
                                        ) : (
                                            <>
                                                Lead Time Approx. <strong>{variation.lead_time_value} {(variation.lead_time_units == 'Week(s)' || variation.lead_time_units == 'Weeks') ? ('Week(s)'):('Month(s)')}</strong>
                                            </>
                                        )
                                    ) : (
                                        <>
                                            Lead Time Approx. <strong>2-5 Working Days</strong>
                                        </>
                                    )}
                            </div>
                        </>

                    )}
                </>
                ) : (
                    <>
                        {variation.variation_status == 'Obsolete' ? (
                            <div className="text-sm text-gray-600">This product has been made obsolete and is no longer available. Need a replacement?<br/>Please contact us and we can help you find an alternative.</div>
                        ) : ('')}
                        {variation.variation_status == 'Superseded' ? (
                            <div className="text-sm text-gray-600">This product has been made obsolete, but has been replaced by the part listed below.<br/>Please click the button to navigate to the new product.</div>
                        ) : ('')}
                        {variation.variation_status == 'Price On Application' ? (
                            <div className="text-sm text-gray-600">This product is price on application, please contact us for pricing.</div>
                        ) : ('')}
                        </>
                )}
            </div>
        </>
    );
}

export default Stock;